import { render } from "./post-smtp-card.vue?vue&type=template&id=36caffee&scoped=true"
import script from "./post-smtp-card.vue?vue&type=script&lang=js"
export * from "./post-smtp-card.vue?vue&type=script&lang=js"

import "./post-smtp-card.vue?vue&type=style&index=0&id=36caffee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36caffee"]])

export default __exports__